/**
 * Arabic for the hour-by-hour chart on Today's flights. Proposed; pending
 * native aviation review. Flight designators and times are kept as written.
 */
const ar: Record<string, string> = {
  "Busiest at {h}": "الأكثر ازدحاماً عند {h}",
  "movements ({a} in, {d} out)": "حركة ({a} وصول، {d} مغادرة)",
  "Nothing is scheduled today.": "لا شيء مجدول اليوم.",
  happened: "تمّت",
  "as scheduled": "حسب الجدول",
  now: "الآن",
  "Movements by hour of the day": "الحركات حسب ساعة اليوم",
  arrivals: "الوصول",
  departures: "المغادرة",
  "{h}: {a} arrivals, {d} departures": "{h}: {a} وصول، {d} مغادرة",
  "{n} to come": "{n} قادمة",
  "scheduled here: {a} in, {d} out": "المجدول هنا: {a} وصول، {d} مغادرة",
  "click again to close": "انقر مرة أخرى للإغلاق",
  "click to see the flights": "انقر لعرض الرحلات",
  Hour: "الساعة",
  "Movements at {h}": "الحركات عند {h}",
  "{n} arrival|{n} arrivals": "لا وصول|وصول واحد|وصولان|{n} وصولات|{n} وصولاً|{n} وصول",
  "{n} departure|{n} departures": "لا مغادرة|مغادرة واحدة|مغادرتان|{n} مغادرات|{n} مغادرة|{n} مغادرة",
  "{n} passengers filed": "{n} راكباً مسجلاً",
  "schedule had {n} here": "كان الجدول يضع هنا {n}",
  "No movements in this hour.": "لا حركات في هذه الساعة.",
  "Late by": "متأخرة بـ",
  "the hour it happens": "الساعة التي تحدث فيها",
  "the hour it was due": "الساعة المجدولة لها",
  "Count each movement in": "احسب كل حركة في",
  "Chart or table": "رسم أو جدول",
  "{n} still to come today|{n} still to come today":
    "لا شيء قادم اليوم|حركة واحدة قادمة اليوم|حركتان قادمتان اليوم|{n} حركات قادمة اليوم|{n} حركة قادمة اليوم|{n} حركة قادمة اليوم",
  "{n} hour carrying more than the schedule put in it|{n} hours carrying more than the schedule put in them":
    "لا ساعة تحمل أكثر من جدولها|ساعة واحدة تحمل أكثر مما وضعه الجدول فيها|ساعتان تحملان أكثر مما وضعه الجدول فيهما|{n} ساعات تحمل أكثر مما وضعه الجدول فيها|{n} ساعة تحمل أكثر مما وضعه الجدول فيها|{n} ساعة تحمل أكثر مما وضعه الجدول فيها",
  "{n} late|{n} late": "لا متأخرة|واحدة متأخرة|اثنتان متأخرتان|{n} متأخرة|{n} متأخرة|{n} متأخرة",
  "{n} cancelled|{n} canceled": "لا ملغاة|واحدة ملغاة|اثنتان ملغاتان|{n} ملغاة|{n} ملغاة|{n} ملغاة",
};
export default ar;
